import React from 'react';

function CreateTicket() {
  return (
    <div className="container">
      <h2>Crear Ticket</h2>
      <p>Formulario para crear nuevos tickets.</p>
    </div>
  );
}

export default CreateTicket;
